import { createSlice } from "@reduxjs/toolkit";

const initialChannelRequestsState = {
  listLoading: false,
  actionsLoading: false,
  totalCount: 0,
  entities: [],
  exportData: [],
  approveRequest: [], 
  rejectRequest: [], 
};

export const callTypes = {
  list: "list",
  action: "action"
};

export const ChannelRequestsSlice = createSlice({

  name: "channelRequests",
  initialState: initialChannelRequestsState,
  reducers: {
    catchError: (state, action) => {
      state.error = `${action.type}: ${action.payload.error}`;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },
    startCall: (state, action) => {
      state.error = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },
    clearfetchStaffUsers: (state, action) => {
      state.listLoading = false;
      state.error = null;
      state.entities = [];
      state.totalCount = 0;
    },
    emptyList: (state, action) => {
      state.error = null;
      state.entities = [];
      // state.totalCount = 0;
      state.exportData = [];
    },

    channelRequestsList: (state, action) => {
      const { totalCount, entities } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.entities = entities;
      state.totalCount = totalCount;
    },
    channelRequestsExport: (state, action) => {
      const { exportData } = action.payload;
      state.exportData = exportData;
    },
    userChannelApproveRequest: (state, action) => {
      const { approveRequest } = action.payload;
      state.approveRequest = approveRequest;
    },
    userChannelRejectRequest: (state, action) => {
      const { rejectRequest } = action.payload;
      state.rejectRequest = rejectRequest;
    },
  }
});
